module.exports = __webpack_public_path__ + "img/kit.6cc47b61.png";